import { render, staticRenderFns } from "./supplier-ledger.vue?vue&type=template&id=3bd6deba&scoped=true&"
import script from "./supplier-ledger.vue?vue&type=script&lang=js&"
export * from "./supplier-ledger.vue?vue&type=script&lang=js&"
import style0 from "./supplier-ledger.vue?vue&type=style&index=0&id=3bd6deba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd6deba",
  null
  
)

export default component.exports